import axios from '../services/axiosCustom';

const GRAPH_DATASET_ID = process.env.REACT_APP_GRAPH_DATASET_ID || 'abcd09ec9b004beca46f80501b4aa4eb';
const GRAPH_ID = process.env.REACT_APP_GRAPH_ID || GRAPH_DATASET_ID;

export const buildGraphResultParams = ({ node, hops, maxNodes = 500, format = 'json' }) => {
  const params = { format };
  if (node) params.node = node;
  if (hops !== undefined && hops !== null) params.hops = Math.max(0, Math.min(10, hops));
  if (maxNodes) params.max_nodes = Math.max(50, Math.min(1000, maxNodes));
  return params;
};

export const fetchProcessedGraphResult = async (
  nodeId,
  hops,
  maxNodes,
  { apiUrl, apiKey, graphId = GRAPH_ID }
) => {
  const resultParams = buildGraphResultParams({ node: nodeId, hops, maxNodes });
  const resultResponse = await axios.get(
    `${apiUrl}/${graphId}/result`,
    {
      headers: { Authorization: `Bearer ${apiKey}` },
      params: resultParams,
    }
  );

  return resultResponse.data;
};
